var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons"},[_c('a',{staticClass:"button is-twitch",class:{'is-loading': _vm.isLoading},attrs:{"href":_vm.twitchURI},on:{"click":function($event){_vm.isLoading = true}}},[_vm._v(_vm._s(_vm.$t('Login with Twitch')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }